<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>系统管理>店铺信息</p>
         <div class="body">

             <div class="search">
                 <div class="block">
                    <table class="table">
                        <thead class="head">
                            <th><span @click.prevent="componentType='hotelInfo'" >酒店基础信息</span></th>
                            <th><span @click.prevent="componentType='hotelRoom'">订房须知</span></th>
                            <th><span @click.prevent="componentType='hotelService'">服务设施</span></th>
                            <th><span @click.prevent="componentType='hotelTraffic'">交通周边</span></th>
                        </thead>
                    </table>
                </div>
             </div>
         </div>
         <div class="info">
                <component :is="componentType" />
         </div>
    </div>
</template>

<script>
import hotelInfo from '../setup/hotelInfo' //酒店基础信息
import hotelRoom from '../setup/hotelRoom' //订房须知
import hotelService from '../setup/hotelService' //服务设施
import hotelTraffic from '../setup/hotelTraffic' //交通周边
export default {
    data() {
      return {
        componentType:'hotelTraffic',
      }
    },
    components:{hotelInfo,hotelRoom,hotelService,hotelTraffic},
    methods: {
    
  }
  };
</script>

<style scoped>

.block{
    height: 50px;
}

.demonstration{
    line-height: 50px;
    width: 200px;
}

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.table{
    width: 50%;
}

.head th{
    line-height: 50px;
}

.info{
    margin-top: 1%;
    background-color: #FFFFFF;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/setup/storeInfo.vue